import React, { useEffect, useState } from 'react';
import RoleForm from '../../../components/masters/users/roles/RoleForm';
import RoleTable from '../../../components/masters/users/roles/RoleTable';
import { useDispatch, useSelector } from 'react-redux';
import { fetchRoles, addRole, updateRole, deleteRole, setEditingRole, clearEditingRole } from '../../../redux/actions/masters/users/role/roleAction';
import { showConfirm } from '../../../utills/sweetAlert';
import { fetchUsers } from '../../../redux/actions/masters/users/user/userAction';

const outerWrapper = {
  padding: 0,
  margin: 0,
  minHeight: 'calc(100vh - 72px)',
  display: 'flex',
  flexDirection: 'column',
  background: 'transparent',
  marginTop: 24,
};

const containerStyle = {
  display: 'flex',
  flexDirection: 'row',
  gap: 24,
  alignItems: 'stretch',
  width: '100%',
  height: '100%',
  flex: 1,
};

const cardBase = {
  background: '#fff',
  borderRadius: 16,
  boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
  padding: '2rem 1.5rem',
  display: 'flex',
  flexDirection: 'column',
  minWidth: 320,
  flex: 1,
  minHeight: 520,
};

const formContainer = {
  ...cardBase,
  maxWidth: 400,
  flex: '0 1 400px',
  marginRight: 0,
};
const tableContainer = {
  ...cardBase,
  flex: 2,
  minWidth: 340,
  marginLeft: 0,
};

const responsiveStyle = `
@media (max-width: 900px) {
  .role-flex {
    flex-direction: column !important;
    gap: 20px !important;
  }
  .role-form, .role-table {
    max-width: 100% !important;
    min-width: 0 !important;
    width: 100% !important;
  }
}
`;

const RolePage = () => {
  const dispatch = useDispatch();
  const { list, loading, error, editingRole } = useSelector((state) => state.roles);
  const { list: users } = useSelector((state) => state.users);
  const [formSuccess, setFormSuccess] = useState('');
  const [formError, setFormError] = useState('');
  const [formResetKey, setFormResetKey] = useState(0);

  useEffect(() => {
    dispatch(fetchRoles());
    dispatch(fetchUsers());
  }, [dispatch]);

  const handleAddOrUpdate = async (role) => {
    setFormSuccess('');
    setFormError('');
    if (editingRole) {
      await dispatch(updateRole({ id: editingRole.role_id, role }));
      dispatch(clearEditingRole());
      dispatch(fetchRoles());
      setFormSuccess('Role updated successfully!');
    } else {
      await dispatch(addRole(role));
      dispatch(fetchRoles());
      setFormSuccess('Role added successfully!');
    }
  };

  const handleEdit = (role) => {
    dispatch(setEditingRole(role));
  };

  const handleDelete = async (id, role_name) => {
    const confirmed = await showConfirm('Delete Role', `Are you sure you want to delete role: ${role_name}?`, 'Delete', 'Cancel');
    if (confirmed) {
      dispatch(deleteRole(id));
    }
  };

  const handleCancelEdit = () => {
    dispatch(clearEditingRole());
  };

  const handleNew = () => {
    dispatch(clearEditingRole());
    setFormSuccess('');
    setFormError('');
    setFormResetKey(k => k + 1);
  };

  return (
    <div style={outerWrapper}>
      <style>{responsiveStyle}</style>
      <div style={containerStyle} className="role-flex">
        <div style={tableContainer} className="role-table">
          {loading ? (
            <div>Loading...</div>
          ) : error ? (
            <div style={{ color: 'red' }}>{error}</div>
          ) : (
            <RoleTable roles={list} onEdit={handleEdit} onDelete={handleDelete} onNew={handleNew} />
          )}
        </div>
        <div style={formContainer} className="role-form">
          <RoleForm
            key={formResetKey}
            resetKey={formResetKey}
            onSubmit={handleAddOrUpdate}
            editingRole={editingRole}
            onCancel={handleCancelEdit}
            roles={list}
            users={users}
            formSuccess={formSuccess}
            formError={formError}
            setFormSuccess={setFormSuccess}
            setFormError={setFormError}
          />
        </div>
      </div>
    </div>
  );
};

export default RolePage; 